import React, {Component} from 'react';
import PropTypes from 'prop-types'
import NotificationSystem from 'react-notification-system';
import {BeatLoader} from 'react-spinners';
import StepZilla from "react-stepzilla";
import {_addNotification,_addNotificationError} from '../../../server/util';
import {get, postWithHeaders, patch} from "../../../server/actions";
import {lunchBreakfastModal,personModal,personType,incomeModal, IncomFreqency}from './schoolLunchBreakfastModal';
import Welcome from './welcome';
import FirstParentInfo from './firstParentInfo';
import StudentsList from './studentsList'
import AssistanceProgram from './assistancePrograms';
import FosterQualify from './fosterQualify';
import MigrantQualify from './migrantQualify';
import IncomeOption from './incomeOption';
import AddChild from './addChild';
import AddAdult from './addAdult';
import AddChildIncome from './addChildIncome';
import AddAdultIncome from './addAdultIncome';
import AddressDetails from './addressDetails';
import RacialEthnic from './racialEthnic';
import SSN from './ssn';
import Agreement from './agreement';
import StepFinal from './stepFinal';
import SummaryReport from './summery';
import moment from 'moment';
import BeforeBegin from './beforeBegin';
import FreeReducedProgramFAQ from './freeReducedProgramFAQ';
import { translate, Trans} from "react-i18next";
class LunchBreakfastProgram extends Component {
    constructor(props) {
        super(props)
        this.state={
            loading:false,
            initStep:0,
            appliedStudents:[],
            lunchBreakfastObj: JSON.parse(JSON.stringify(lunchBreakfastModal)),
            schoolInfo:{id:0,name:'',sessionYear:'',pdfUrl:'', schoolYearValue:''},
            studentList:[],
            districtStatus:""
        }
        this.buildStudentsList=this.buildStudentsList.bind(this)
        console.log("draftData:::::::::#####",this.props.draftData);
        console.log("this.state.lunchBreakfastObj for draftData:::::",this.state.lunchBreakfastObj);
        if(Object.keys(this.props.draftData).length===0){
            console.log("draftData lenght is zero");
            this.props.draftData.householdAppInfo = this.state.lunchBreakfastObj.persons;
        }
    }
    componentWillMount= async ()=>{
        const { match: { params } } = this.props;
        //console.log("this.context.router.route.location.state:::::::::",this.context.router.route.location.state);
        const {schoolObject,sid,studentList,districtStatus} = this.context.router.route.location.state;
        console.log(studentList,districtStatus)
        let _schoolInfoObj=this.state.schoolInfo;
        _schoolInfoObj.id=sid
        if(Object.keys(schoolObject).length>0){
            _schoolInfoObj.name=(schoolObject.schoolName||'')
            _schoolInfoObj.sessionYear=schoolObject.sessionYear.schoolYearValue
            _schoolInfoObj.schoolYearValue=schoolObject.sessionYear.schoolYear
            _schoolInfoObj.schoolPdfUrl=schoolObject.sessionYear.schoolPdfUrl
        }            
        else{
            _schoolInfoObj.name='';
            _schoolInfoObj.sessionYear=''
            _schoolInfoObj.schoolPdfUrl=''
        }     
        this.setState({schoolInfo:_schoolInfoObj,studentList,districtStatus}
            ,this.buildStudentsList(studentList,districtStatus))
            //console.log("StudentList#####:::::::::",this.props.studentList);
           // console.log("Props ::::",this.props);
    }

    buildStudentsList=(studentList = [],districtStatus=false)=>{
        let _finalStudentsArray=[];
        let _lunchBreakfastObj=this.state.lunchBreakfastObj;
       // console.log("_lunchBreakfastObj:::::::::::::::::",this.state.lunchBreakfastObj);
        _lunchBreakfastObj.mealSchoolId=this.state.schoolInfo.id;
        _lunchBreakfastObj.persons[0].contact.email=sessionStorage.getItem('loggedInUserInfo');
        _lunchBreakfastObj.studentList=[]
        _lunchBreakfastObj.allStudentList=[]
        _lunchBreakfastObj.childList=[];
        _lunchBreakfastObj.adultList=[];
        let _studentsList=[]
        let studentListArray = []
        if(districtStatus){
            studentListArray = studentList
        }else{
            studentListArray = this.props.studentList
        }
        console.log("studentListArray::::::",studentListArray);
        console.log("this.props.draftData:::::::",this.props.draftData);
       // _lunchBreakfastObj.assistancePrograms = this.props.draftData['householdAppInfo'][0]['assistancePrograms'];
       if(this.props.draftData.hasOwnProperty("applicationId")){
        _lunchBreakfastObj.applicationId=this.props.draftData.applicationId;
        }
       console.log("lunchBreakfastObj::::::",this.state.lunchBreakfastObj);
       let indexForAsst = this.props.draftData.householdAppInfo.findIndex(record =>  record.assistancePrograms != null);
       //console.log("indexForAsst::::::::",indexForAsst);
       if(indexForAsst != -1){
        _lunchBreakfastObj['assistancePrograms'] = this.props.draftData['householdAppInfo'][indexForAsst]['assistancePrograms'];
       }else{
        _lunchBreakfastObj['assistancePrograms'] = this.state.lunchBreakfastObj.assistancePrograms;
       }
        _lunchBreakfastObj["persons"] = this.props.draftData["householdAppInfo"].filter(item => (item.personType === "Adult" && item.contact !== null));
        _lunchBreakfastObj["childList"] = this.props.draftData["householdAppInfo"].filter(item => item.personType === "Child"&&item.mealSchoolId==null);
        _lunchBreakfastObj["adultList"] = this.props.draftData["householdAppInfo"].filter(item => item.personType === "Adult" && item.contact === null);
        _lunchBreakfastObj['isIncomeAfter'] = this.props.draftData['incomeAfter'];
        _lunchBreakfastObj['isAllFoster'] = this.props.draftData['allFoster'];
           studentListArray.map((student,k)=>{
            if(districtStatus || student.mealSchoolId==this.state.schoolInfo.id){
                let _personModal=JSON.parse(JSON.stringify(personModal));
                _personModal.personType=personType.student;
                _personModal.fname= student.firstName;
                _personModal.lname= student.lastName;
                _personModal.mname= "";
                _personModal.income=[
                    //Object.assign({},incomeModal)
                ]
                _personModal.grade= student.gradeName;
                _personModal.studentRecId=student.id;
                _personModal.id=k;

                console.log("this.state.draftData:::::",this.props.draftData);
                let index = this.props.draftData.householdAppInfo.findIndex(record =>  (record.studentRecId && record.studentRecId.toString() === student.id) || (record.mealSchoolId && record.fname == student.firstName && record.lname == student.lastName));
                console.log("Index::::::",index);
                if (index !== -1) {
                    _personModal.isSelected=true;
                    // if (this.props.draftData.householdAppInfo[index].mealSchoolId) {
                    //     _personModal.personType = "Student";
                    //   }
                    _personModal.ethenticity=this.props.draftData.householdAppInfo[index]['ethenticity'];
                    _personModal.race=this.props.draftData.householdAppInfo[index]['race'];
                    _personModal.liveUnderFosterCare=this.props.draftData.householdAppInfo[index]['liveUnderFosterCare'];
                    _personModal.mcKinneyVentoHomeless=this.props.draftData.householdAppInfo[index]['mcKinneyVentoHomeless'];
                    _personModal.migrantEducationPrg=this.props.draftData.householdAppInfo[index]['migrantEducationPrg'];
                    _personModal.runaway=this.props.draftData.householdAppInfo[index]['runaway'];
                    _personModal.headStart=this.props.draftData.householdAppInfo[index]['headStart'];
                    _personModal.homelessOrMigrantOrRunaway=this.props.draftData.householdAppInfo[index]['homelessOrMigrantOrRunaway'];
                    _personModal.income=this.props.draftData.householdAppInfo[index]['income'];
                 }else{
                
                _personModal.isSelected=false;
                }
                if(districtStatus){
                    _personModal.mealSchoolId=student.mealSchoolId
                }
                _studentsList.push(_personModal);
            }
        });
        console.log("_studentsList:::::",_studentsList);
        if(_studentsList.length===0){
            _lunchBreakfastObj.studentList=[]
            this.setState({lunchBreakfastObj:_lunchBreakfastObj});
            return;
        }
        // Only students on a pending application are blocked; approved/denied/in-complete/cancelled can resubmit
        const _studentRecIds=_studentsList.map(stu=>stu.studentRecId).join(',');
         get('/pendingAppStudentRecIds?studentRecIds='+_studentRecIds + '&access_token=').then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(pendingIds => {
            const _pendingIds=(pendingIds||[]).map(id=>id+'');
            _studentsList.map((studentRec)=>{
                if(!_pendingIds.includes(studentRec.studentRecId+'')){
                    _finalStudentsArray.push(studentRec)
                }
            });
            _lunchBreakfastObj.studentList=_finalStudentsArray
            this.setState({lunchBreakfastObj:_lunchBreakfastObj});
        }).catch(
                (error) => {
                    //_addNotificationError('Activation failed. Please try again later', this);
                    console.log('already applied students', error);
                    _lunchBreakfastObj.studentList=_studentsList
                    this.setState({lunchBreakfastObj:_lunchBreakfastObj});
                }
            );
            }

    getFrequencyName=(freq)=>{
        let frequency= IncomFreqency.find(inf=>{
             return inf.value==freq;
         });
         return((frequency||{}).text||'');
     }
    getAnnualIncome=(Income)=>{
        let amount=0.00;
        Income.map(inc=>{
            amount=amount+(parseInt(inc.frequency)* parseFloat(inc.amount))
        });    
        return amount;
    }
    getTotalIncome=(students)=>{
        let amount=0.00;
        students.map((student)=>{
            amount=amount+this.getAnnualIncome(student.income);
        });
        return amount
    }
    buildApplicationUI=(content, appData, t)=>{
        if(Object.keys(appData).length>0){
        let mainDev=document.createElement('div');
        let title=document.createElement('div');
        let heading=document.createElement('h3');
        heading.innerHTML=t("Household Application for Free and Reduced Price School Meals");
        heading.style.color='red';
        heading.style.textAlign='center';
        title.appendChild(heading);
        mainDev.appendChild(title);
    
        let appNo_date=document.createElement('div');
        let leftDiv=document.createElement('div');
        leftDiv.style.cssFloat='left';
        leftDiv.style.maxWidth='50%';
        leftDiv.innerHTML='<p><strong>'+t('Application Id:')+'</strong></p>';
        appNo_date.appendChild(leftDiv);
    
        let rightDiv=document.createElement('div');
        rightDiv.style.cssFloat='right';
        rightDiv.style.textAlign='right';
        rightDiv.style.maxWidth='50%';
        rightDiv.innerHTML=`<p>${t('Date')}: <strong>${moment(appData.date,'MMDDYYYY').format('MM-DD-YYYY')}</strong></p>`;
        appNo_date.appendChild(rightDiv);
        mainDev.appendChild(appNo_date);
    
        let childDiv=document.createElement('div');
        let childTable='<table width="100%" border=1 style="border-collapse: collapse; border: 1px solid #ddd; font-size:12px">';
        let childHead='<thead><tr>'+
                '<th rowspan="2" style="width:20%">'+t('First Name')+'</th>'+
                '<th rowspan="2" style="width:20%">'+t('Last Name')+'</th>'+
                '<th rowspan="2" style="width:7%">'+t('Grade')+'</th>'+
                '<th colspan="2" style="width:15%">'+t('Student?')+'</th>'+
                '<th rowspan="2" style="width:10%">'+t('Foster Child')+'</th>'+
                '<th rowspan="2" style="width=10%">'+t('Runaway Program')+'</th>'+
                '<th rowspan="2" style="width=10%">'+t('McKinney-Vento Homeless')+'</th>'+
                '<th rowspan="2" style="width=10%">'+t('Migrant Education Program')+'</th>'+
                '<th rowspan="2" style="width=10%">'+t('Head Start')+'</th>'+
                '</tr><tr>'+
                '<th>'+t('Yes')+'</th>'+
                '<th>'+t('No')+'</th>'+
                '</tr></thead>';
        let childStudents='';
        (appData.householdAppInfo||[]).map((student)=>{
                if(student.personType===personType.student){
                   /*  let homelessString='';
                    if( student.runaway){
                        (student.homelessOrMigrantOrRunawayOptions||[]).map(itm=>{
                            homelessString=homelessString+ '<span>&#10003;</span> <span>'+itm+'</span><br />';
                        });
                    } */
                    childStudents=childStudents+'<tr><td>'+student.fname+'</td>'+
                    '<td>'+student.lname+'</td>'+
                    '<td>'+student.grade+'</td>'+
                    '<td style="text-align:center">'+(student.personType===personType.student?'<span>&#10003;</span>':'')+'</td>'+
                    '<td style="text-align:center">'+(student.personType!==personType.student?'<span>&#10003;</span>':'')+'</td>'+
                    '<td style="text-align:center">'+(student.liveUnderFosterCare?'<span>&#10003;</span>':'')+'</td>'+
                    '<td style="text-align:center">'+(student.runaway?'<span>&#10003;</span>':'')+'</td>'+
                    '<td style="text-align:center">'+(student.mcKinneyVentoHomeless?'<span>&#10003;</span>':'')+'</td>'+
                    '<td style="text-align:center">'+(student.migrantEducationPrg?'<span>&#10003;</span>':'')+'</td>'+
                    '<td style="text-align:center">'+(student.headStart?'<span>&#10003;</span>':'')+'</td></tr>';
                }
        });
        let childs='';
        (appData.householdAppInfo||[]).map((student)=>{
            if(student.personType===personType.child){
               /*  let homelessString='';
                    if( student.runaway){
                        (student.homelessOrMigrantOrRunawayOptions||[]).map(itm=>{
                            homelessString=homelessString+ '<span>&#10003;</span> <span>'+itm+'</span><br />';
                        });
                    } */
                childs=childs+'<tr><td>'+student.fname+'</td>'+
                '<td>'+student.lname+'</td>'+
                '<td>'+student.grade+'</td>'+
                '<td style="text-align:center">'+(student.personType===personType.student?'<span>&#10003;</span>':'')+'</td>'+
                '<td style="text-align:center">'+(student.personType!==personType.student?'<span>&#10003;</span>':'')+'</td>'+
                '<td style="text-align:center">'+(student.liveUnderFosterCare?'<span>&#10003;</span>':'')+'</td>'+
                '<td style="text-align:center">'+(student.runaway?'<span>&#10003;</span>':'')+'</td>'+
                '<td style="text-align:center">'+(student.mcKinneyVentoHomeless?'<span>&#10003;</span>':'')+'</td>'+
                '<td style="text-align:center">'+(student.migrantEducationPrg?'<span>&#10003;</span>':'')+'</td>'+
                '<td style="text-align:center">'+(student.headStart?'<span>&#10003;</span>':'')+'</td></tr>';
            }
        });
        let programDev=document.createElement('div');
        let programLbl='<p style="font-size: 12px;"><strong>'+t('Do any Household Members (including you) currently participate in one or more of the following assistance programs: SNAP, TANF, or FDPIR?')+'</p><table width="100%" border=1 style="border-collapse: collapse; border: 1px solid #ddd; font-size:12px">';
        let programList='';
        ((appData.householdAppInfo[0]||{}).assistancePrograms||[]).map((program,p)=>{
            programList=programList+'<tr style="font-size: 12px;"><td style="width:50%"><strong>'+t(program.name)+' :</strong></td><td><label>'+program.caseNumber+'</label></td></tr></tr>'
        })
        programDev.innerHtml=programLbl+programList+'</table>';
        
        let incomeDev=document.createElement('div');  
    
        let incomeBody='';
        let isIncomeExist=(appData.householdAppInfo||[]).some((person)=>{
            return person.income.length>0;
        });
        if(isIncomeExist){
            let incomeHeader='<p style="font-size:14px;  margin:5px 0px;"><strong>'+t('Report Income for ALL Household Members')+'</strong></p><table width="100%" border=1 style="border-collapse: collapse; border: 1px solid #ddd; font-size:12px">'+
        '<tr><th rowspan="2">Name</th><th colspan="3" style="text-align:center;">'+t('Income ($)')+'</th></tr><tr><th>'+t('Source')+'</th><th>'+t('Frequency')+'</th><th>'+t('Amount ($)')+'</th></tr>';
            appData.householdAppInfo.map((person)=>{
                if(person.income.length>0){
                    incomeBody=incomeBody+'<tr><td rowspan='+(person.income.length+1)+'>'+person.fname+' '+person.lname+'</td><td colspan="3" style="padding:0; border:0;"></td></tr>'
                    person.income.map(income=>{
                        incomeBody=incomeBody+'<tr><td>'+income.source+'</td><td>'+ this.getFrequencyName(income.frequency)+'</td><td>'+income.amount+'</td></tr>' 
                    })
                }
            })
            incomeDev.innerHTML=incomeHeader+'<tbody>'+incomeBody+'</tbody>'+'</table>';
        }
        let addressDev='<p style="font-size:14px;  margin:5px 0px;"><strong>'+t('Contact information')+'</strong></p>'+
        '<div class="table-responsive"><table width="100%" style="font-size:12px"><tr><td><span><strong>'+t('Email')+' :</strong></span><span> '+appData.householdAppInfo[0].contact.email+
        '</span></td><td><span><strong>'+t('Phone')+':</strong></span><span> '+appData.householdAppInfo[0].contact.phone+
        '</span></td><td><span><strong>'+t('Address 1')+' :</strong></span><span> '+appData.householdAppInfo[0].contact.street1+'</span></td></tr>'+
        '<tr><td><span><strong>'+t('Address 2')+' :</strong></span><span> '+appData.householdAppInfo[0].contact.street2+
        '</span></td><td><span><strong>'+t('City')+' :</strong></span><span> '+appData.householdAppInfo[0].contact.city+'</span></td>'+
        '<td><span><strong>'+t('State')+' :</strong></span><span> '+appData.householdAppInfo[0].contact.state+'</span></td></tr>'+
        '<tr><td><span><strong>'+t('Zip')+' :</strong></span><span> '+appData.householdAppInfo[0].contact.zip+'</span></td><td></td><td></td></tr>'+
        '</table></div>';
        let ssnDev='<p style="font-size:12px"><strong>'+t('Last Four Digits of Social Security Number (SSN) of Primary Wage Earner or Other Adult Household Member')+'</strong>'+
        ': '+(appData.householdAppInfo[0].noSSN===true? 'No SSN': appData.householdAppInfo[0].ssn)+'</p>';
    
        let racialDev="<p style='font-size:14px;  margin:5px 0px;'><strong>"+t("Children's Racial and Ethnic Identities")+"</strong></p>";
        racialDev=racialDev+'<table border=1 width="100%" style="border-collapse: collapse; border: 1px solid #ddd;font-size:12px"><tr><th style="width:25%">'+t('Name')+'</th><th style="width:25%">'+t('Ethnicity')+'</th><th>'+t('Race')+'</th></tr>'
        appData.householdAppInfo.map((student)=>{
            if(student.personType===personType.student){
                racialDev=racialDev+'<tr><td>'+student.fname+' '+student.lname+
                '</td><td>'+(student.ethenticity||"")+'</td><td>'+(student.race||[]).join(', ')+'</td></tr>';
            }
        });
        racialDev=racialDev+'</table>';
        //let houseHoldDiv= this.getTotalIncome(appData.householdAppInfo)>0?('<p style="font-size:12px; margin:5px 0px;"><span><strong>Total Household Income per Annum ($) : </strong></span><span>'+this.getTotalIncome(appData.householdAppInfo)+'</sp></p>'):''+ '';
        // '<p style="font-size:12px; margin:5px 0px;"><span><strong>Total Household Size : </strong></span><span>'+appData.householdAppInfo.length+'</span></p>';
        
        let applicentDev='<div style="padding:10px; float:right"><p style="text-align:left;margin: 2; padding-bottom:5px;padding-top:10px; font-size: 14px;">'+t('Submitted By')+',</p>'+
        '<strong style="text-align: left;display: block;font: 16px bold;text-transform: uppercase;">'+appData.householdAppInfo[0].fname+' '+appData.householdAppInfo[0].lname+'</stro>'
        +'<span style="text-align: left;display: block;font: 13px italic;">'+t('Date')+' :'+moment(appData.date,'MMDDYYYY').format('YYYY-MM-DD HH:MM:SS')+'</span></div>'
        childDiv.innerHTML=childTable+childHead+
        '<tbody>'+childStudents+childs+
        '</tbody></table>'+programDev.innerHtml+incomeDev.innerHTML+
        addressDev+ssnDev+racialDev+
        //houseHoldDiv+
        applicentDev;
        mainDev.appendChild(childDiv);
    
        content.innerHTML = mainDev.outerHTML;
    }
    }
    componentDidMount=()=>{
        this._notificationSystem = this.refs.notificationSystem;
    }
    showHidefaqsidebar=()=>{
        let myButtonClasses = document.getElementById("faqsidebar").classList;
        if (myButtonClasses.contains("active")) {
            myButtonClasses.remove("active");                                    
        } else {                                    
            myButtonClasses.add("active");                                    
        }
    }
    render() {
        const steps =[
            {id:0,name:'Welcome',component:<Welcome schoolInfo={this.state.schoolInfo} />},
            {id:1,name:'Before you begin', component:<BeforeBegin schoolInfo={this.state.schoolInfo} />},
            {id:2,name:'Parent Info', component:<FirstParentInfo lunchObj={this.state.lunchBreakfastObj}
           // updateLunchObj={this.updateLunchObj}
                onApplicantFieldChange={(key,value)=>{
                    let _lunchBreakfastObj=this.state.lunchBreakfastObj
                    _lunchBreakfastObj.persons[0][key]=value;
                    this.setState({lunchBreakfastObj:_lunchBreakfastObj})
                }}
            />},
            {id:3,name:'Students', component:<StudentsList lunchObj={this.state.lunchBreakfastObj} allStudentList={this.props.studentList} draftData={this.props.draftData} 
            schoolInfo={this.state.schoolInfo} 
            isDistrict={this.state.districtStatus}
                onStudentSelectChange={(index,status)=>{ 
                    let _lunchBreakfastObj=this.state.lunchBreakfastObj
                    _lunchBreakfastObj.studentList[index].isSelected=status;
                    this.setState({lunchBreakfastObj:_lunchBreakfastObj}) 
                }}
            />},
            {id:4,name:"Assistance Programs", component:<AssistanceProgram lunchObj={this.state.lunchBreakfastObj}  schoolInfo={this.state.schoolInfo}  isDistrict={this.state.districtStatus}
                onProgramSelectChange={(index,status)=>{
                    let _lunchBreakfastObj=this.state.lunchBreakfastObj
                    _lunchBreakfastObj.assistancePrograms[index].isApplicable=status;
                    if(!status){
                        _lunchBreakfastObj.assistancePrograms[index].caseNumber='';
                    }
                    this.setState({lunchBreakfastObj:_lunchBreakfastObj}) 
                }} onProgramCardNoChanged={(index,value)=>{
                    let _lunchBreakfastObj=this.state.lunchBreakfastObj
                    _lunchBreakfastObj.assistancePrograms[index].caseNumber=value;
                    this.setState({lunchBreakfastObj:_lunchBreakfastObj});
                }} /> },
            {id:5,name:'Foster Qualify', component:<FosterQualify lunchObj={this.state.lunchBreakfastObj}  schoolInfo={this.state.schoolInfo}  isDistrict={this.state.districtStatus}
                onAllFosterSelectChange={(key,status)=>{
                    let _lunchBreakfastObj=this.state.lunchBreakfastObj
                   _lunchBreakfastObj[key]=status;
                   if(status===false){
                        _lunchBreakfastObj.studentList.map((stu,i)=>{
                        if(stu.isSelected===true){
                            _lunchBreakfastObj.studentList[i].liveUnderFosterCare=false
                        }
                    });
                   }                   
                   this.setState({lunchBreakfastObj:_lunchBreakfastObj})
                }}
                onStudentFasterSelectChange={(index,status)=>{
                    let _lunchBreakfastObj=this.state.lunchBreakfastObj
                    _lunchBreakfastObj.studentList[index].liveUnderFosterCare=status;
                    this.setState({lunchBreakfastObj:_lunchBreakfastObj}) 
                }}
            />},
            {id:6,name:'Migrant Qualify', component:<MigrantQualify lunchObj={this.state.lunchBreakfastObj}  schoolInfo={this.state.schoolInfo}  isDistrict={this.state.districtStatus}
            onMcKinneyVentoProgramStatusChange={(index,status)=>{ 
                let _lunchBreakfastObj=this.state.lunchBreakfastObj
                    _lunchBreakfastObj.studentList[index].mcKinneyVentoHomeless=status;
                    
                    this.setState({lunchBreakfastObj:_lunchBreakfastObj})
            }} 
            onMigrantEducationStatusChange={(index,status)=>{
                let _lunchBreakfastObj=this.state.lunchBreakfastObj
                    _lunchBreakfastObj.studentList[index].migrantEducationPrg=status;
                    
                    this.setState({lunchBreakfastObj:_lunchBreakfastObj})
            }} 
            onStudentMigrantStatusChange={(index,status)=>{
                let _lunchBreakfastObj=this.state.lunchBreakfastObj
                    _lunchBreakfastObj.studentList[index].runaway=status;

                    this.setState({lunchBreakfastObj:_lunchBreakfastObj})
            }}
            onHeadStartStatusChange={(index,status)=>{
                let _lunchBreakfastObj=this.state.lunchBreakfastObj
                    _lunchBreakfastObj.studentList[index].headStart=status;

                    this.setState({lunchBreakfastObj:_lunchBreakfastObj})
            }}  />},
            {id:7,name:'Income Option', component:<IncomeOption lunchObj={this.state.lunchBreakfastObj}  schoolInfo={this.state.schoolInfo}  isDistrict={this.state.districtStatus}
             onSelectionChange={(key,status)=>{
                let _lunchBreakfastObj=this.state.lunchBreakfastObj
                    _lunchBreakfastObj[key]=status;
                    this.setState({lunchBreakfastObj:_lunchBreakfastObj})
             }} />},
            {id:8,name:'Add Child', component:<AddChild lunchObj={this.state.lunchBreakfastObj} schoolInfo={this.state.schoolInfo}  isDistrict={this.state.districtStatus} onAddNewChild={()=>{
                let newChild=JSON.parse(JSON.stringify(personModal))
                newChild.personType=personType.child;
                let _lunchBreakfastObj=this.state.lunchBreakfastObj;
                _lunchBreakfastObj.childList.push(newChild);
                this.setState({lunchBreakfastObj:_lunchBreakfastObj})
            }} onDeleteChild={(index)=>{
                let _lunchBreakfastObj=this.state.lunchBreakfastObj;
                _lunchBreakfastObj.childList.splice(index, 1);
                this.setState({lunchBreakfastObj:_lunchBreakfastObj})

            }} onFieldValueChange={(index,key,value)=>{
                let _lunchBreakfastObj=this.state.lunchBreakfastObj;
                _lunchBreakfastObj.childList[index][key]=value;
                this.setState({lunchBreakfastObj:_lunchBreakfastObj})
            }} />},            
            {id:9,name:'Add Child Income', component:<AddChildIncome lunchObj={this.state.lunchBreakfastObj}  schoolInfo={this.state.schoolInfo}  isDistrict={this.state.districtStatus}
            onFieldValueChange={(mainIndex,mainKey,subindex,subKey,value)=>{
                let _lunchBreakfastObj=this.state.lunchBreakfastObj;
                _lunchBreakfastObj[mainKey][mainIndex].income[subindex][subKey]=value;
                this.setState({lunchBreakfastObj:_lunchBreakfastObj})
            }}
            addIncome={(mainIndex,mainKey)=>{
                let _lunchBreakfastObj=this.state.lunchBreakfastObj;
                _lunchBreakfastObj[mainKey][mainIndex].income.push(Object.assign({},incomeModal));
                this.setState({lunchBreakfastObj:_lunchBreakfastObj})
            }}
            onDeleteIncome={(mainIndex,mainKey,subIndex)=>{
                let _lunchBreakfastObj=this.state.lunchBreakfastObj;
                _lunchBreakfastObj[mainKey][mainIndex].income.splice(subIndex,1);
                this.setState({lunchBreakfastObj:_lunchBreakfastObj})
            }}
            />},
            {id:10,name:'Add Adult', component:<AddAdult lunchObj={this.state.lunchBreakfastObj}  schoolInfo={this.state.schoolInfo}  isDistrict={this.state.districtStatus}
            onAddNewAdult={()=>{
                let newAdult=JSON.parse(JSON.stringify(personModal))
                newAdult.personType=personType.adult;
                let _lunchBreakfastObj=this.state.lunchBreakfastObj;
                _lunchBreakfastObj.adultList.push(newAdult);
                this.setState({lunchBreakfastObj:_lunchBreakfastObj})
            }} onDeleteAdult={(index)=>{
                let _lunchBreakfastObj=this.state.lunchBreakfastObj;
                _lunchBreakfastObj.adultList.splice(index, 1);
                this.setState({lunchBreakfastObj:_lunchBreakfastObj})

            }} onFieldValueChange={(index,key,value)=>{
                let _lunchBreakfastObj=this.state.lunchBreakfastObj;
                _lunchBreakfastObj.adultList[index][key]=value;
                this.setState({lunchBreakfastObj:_lunchBreakfastObj})
            }}
             />},
            {id:11,name:'Add Adult Income', component:<AddAdultIncome 
            lunchObj={this.state.lunchBreakfastObj}  schoolInfo={this.state.schoolInfo}  isDistrict={this.state.districtStatus}
            onFieldValueChange={(mainIndex,mainKey,subindex,subKey,value)=>{
                let _lunchBreakfastObj=this.state.lunchBreakfastObj;
                _lunchBreakfastObj[mainKey][mainIndex].income[subindex][subKey]=value;
                this.setState({lunchBreakfastObj:_lunchBreakfastObj})
            }}
            addIncome={(mainIndex,mainKey)=>{
                let _lunchBreakfastObj=this.state.lunchBreakfastObj;
                _lunchBreakfastObj[mainKey][mainIndex].income.push(Object.assign({},incomeModal));
                this.setState({lunchBreakfastObj:_lunchBreakfastObj})
            }}
            onDeleteIncome={(mainIndex,mainKey,subIndex)=>{
                let _lunchBreakfastObj=this.state.lunchBreakfastObj;
                _lunchBreakfastObj[mainKey][mainIndex].income.splice(subIndex,1);
                this.setState({lunchBreakfastObj:_lunchBreakfastObj})
            }}  />},
            {id:12,name:'Address Details', component:<AddressDetails lunchObj={this.state.lunchBreakfastObj}  schoolInfo={this.state.schoolInfo}  isDistrict={this.state.districtStatus} 
            onAddressChange={(key,value)=>{
                let _lunchBreakfastObj=this.state.lunchBreakfastObj
                    _lunchBreakfastObj.persons[0].contact[key]=value;
                    this.setState({lunchBreakfastObj:_lunchBreakfastObj})
            }} />},
            {id:13,name:'Racial & Ethnic', component:<RacialEthnic lunchObj={this.state.lunchBreakfastObj}
            schoolInfo={this.state.schoolInfo}  isDistrict={this.state.districtStatus}
            onEthnicChange={(index,key,status)=>{
                let _lunchBreakfastObj=this.state.lunchBreakfastObj
                    _lunchBreakfastObj.studentList[index][key]=status;
                    this.setState({lunchBreakfastObj:_lunchBreakfastObj})
            }} onRacialChange={(index,value,status)=>{
                let _lunchBreakfastObj=this.state.lunchBreakfastObj;
                let raceArray=[]
                if(_lunchBreakfastObj.studentList[index].race.length>0){
                    raceArray=_lunchBreakfastObj.studentList[index].race;
                }                
                if(_lunchBreakfastObj.studentList[index].race.includes(value)){                    
                    var idx = raceArray.indexOf(value);
                    if (idx > -1) {
                         raceArray.splice(idx, 1);
                    }          
                }
                if(status){
                    raceArray.push(value);
                }  
                _lunchBreakfastObj.studentList[index].race=raceArray              
                this.setState({lunchBreakfastObj:_lunchBreakfastObj})
            }} />},
            {id:14,name:'SSN', component:<SSN lunchObj={this.state.lunchBreakfastObj}  schoolInfo={this.state.schoolInfo}  isDistrict={this.state.districtStatus}
            onSSNChange={(key,value)=>{
                let _lunchBreakfastObj=this.state.lunchBreakfastObj
                    _lunchBreakfastObj.persons[0][key]=value;
                    this.setState({lunchBreakfastObj:_lunchBreakfastObj})
            }} onNoSSNChange={(key,status)=>{
                let _lunchBreakfastObj=this.state.lunchBreakfastObj
                    _lunchBreakfastObj.persons[0][key]=status;
                    this.setState({lunchBreakfastObj:_lunchBreakfastObj})
            }}  />},
            {id:15,name:'Agreement', component:<Agreement lunchObj={this.state.lunchBreakfastObj} refNotify={this} 
             schoolInfo={this.state.schoolInfo}  isDistrict={this.state.districtStatus} />},
            {id:16,name:'Summery', component:<SummaryReport lunchObj={this.state.lunchBreakfastObj} refNotify={this}  isDistrict={this.state.districtStatus}
            schoolInfo={this.state.schoolInfo} buildHtmlUI={(ele,appObj)=>{
                this.buildApplicationUI(ele,appObj, t);
            }} />},
            {id:17,name:"Final", component:<StepFinal />}
        ];
        const { t, i18n } = this.props;
        const changeLanguage = lng => {
            i18n.changeLanguage(lng);
            };
        
    return (
            <div>
                <NotificationSystem ref="notificationSystem"/>                
                    <section className=" full-width clearfix margin-top">
                        <div className='sweet-loading' style={{position: 'fixed', top: '50%', left: '48%', zIndex: '1000'}}>
                            <BeatLoader
                                size={20}
                                color={'#ea7066'}
                                loading={this.state.loading}
                            />
                        </div>
                        <div className="container">
                        <div className='row'>
                            <div className='col-xs-12 col-sm-12 col-md-2 pull-right'>
                                <label ><Trans>Language</Trans> :</label>
                                <select className='form-control form-control-sm' value={i18n.language} onChange={(e)=>{
                                        if((e.target.value||'')==''){
                                            changeLanguage('en');
                                        }
                                        else{
                                            changeLanguage(e.target.value);
                                        }
                                    }}>
                                        <option value={'en'}>English</option>
                                        <option value={'es'}>Spanish</option>
                                    </select>
                            </div>
                        </div>                        
                            <div className="sectionTitle" >
                                <h2 style={{textTransform: 'none'}}>
                                <span><Trans>Application for School Meal Benefits Program</Trans></span>                                
                                    <button className="pull-right btn btn-xs bg-color-4" style={{margin:'0px',color:'#ffffff',marginTop:'10px'}} onClick={(e) => {
                                        e.preventDefault();
                                        let _self=this;
                                        _self.context.router.history.goBack() ;
                                    }}><i class="fa fa-arrow-circle-left" aria-hidden="true"></i> <Trans>Back to home</Trans></button>
                                    <button className="pull-right btn btn-xs bg-color-3" style={{margin:'0px',color:'#ffffff',marginTop:'10px', marginRight:'10px'}} onClick={()=>{
                                            this.showHidefaqsidebar()
                                        }}>
                                        <Trans>Help</Trans>
                                    </button>

                                </h2>
                            </div>
                            <div className="row">
                                <div className="col-xs-12">
                                    <StepZilla steps={steps} 
                                                showNavigation={false}
                                                nextButtonCls= "btn btn-prev btn-xs bg-color-2 pull-right"
                                                backButtonCls= "btn btn-next bg-color-4 btn-xs pull-left"
                                                nextTextOnFinalActionStep= "Save"
                                                nextButtonText= "Continue"
                                                prevBtnOnLastStep={false} 
                                                startAtStep={0}
                                                showSteps={false}
                                                preventEnterSubmission
                                                 />
                                </div>
                            </div>
                        </div>
                        <div className="col-md-12">
                                    <div className="faqsidebar" id="faqsidebar">
                                        <div className="toggle" id="faqsidebar_close" onClick={()=>{
                                            this.showHidefaqsidebar()
                                        }}></div>
                                        <h3>Help</h3>
                                        <div className="scroll">
                                            <FreeReducedProgramFAQ  schoolInfo={this.state.schoolInfo}/>                                            
                                        </div>
                                    </div>
                                </div>
                    </section>
            </div>)
    }
}
LunchBreakfastProgram.contextTypes = {
    router: PropTypes.object.isRequired
}
export default  translate("translations")(LunchBreakfastProgram);




// WEBPACK FOOTER //
// ./src/components/Parent/SchoolLunchBreakfastProgram/lunchBreakfastProgram.jsx